const ROUND = 'stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"';

function note(x: number, y: number, size: number, opacity: number): string {
  const stem = x + 2.4 * size;
  const top = y - 9 * size;
  const fade = opacity === 1 ? '' : ` opacity="${String(opacity)}"`;
  return (
    `<g${fade}>` +
    `<ellipse cx="${String(x)}" cy="${String(y)}" rx="${(2.7 * size).toFixed(2)}" ry="${(2 * size).toFixed(2)}" transform="rotate(-22 ${String(x)} ${String(y)})" fill="currentColor"/>` +
    `<path d="M${stem.toFixed(2)} ${(y - 0.5 * size).toFixed(2)}V${top.toFixed(2)}q${(3.4 * size).toFixed(2)} ${(1.4 * size).toFixed(2)} ${(2.6 * size).toFixed(2)} ${(5 * size).toFixed(2)}" fill="none" ${ROUND} stroke-width="${(1.5 * size).toFixed(2)}"/>` +
    '</g>'
  );
}

export const BABACOOL_MARK =
  note(5.5, 19, 1.2, 1) + note(12.6, 16.6, 0.92, 0.6) + note(18.6, 14.4, 0.7, 0.35);

export const HALF_TIME_ICON =
  `<circle cx="12" cy="12" r="9.6" fill="none" ${ROUND} stroke-width="1.8" stroke-dasharray="3.2 3.1"/>` +
  `<ellipse cx="10.6" cy="15.2" rx="3" ry="2.2" transform="rotate(-22 10.6 15.2)" fill="none" ${ROUND} stroke-width="1.7"/>` +
  `<path d="M13.4 14.4V6.4" fill="none" ${ROUND} stroke-width="1.7"/>`;
